/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Test_ReconnectingInputs */



/**
* | output |
* | --- |
* | "Waiting for reconnection…" |
*
* @param {Mesh_Test_ReconnectingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_test_reconnecting = /** @type {((inputs?: Mesh_Test_ReconnectingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Test_ReconnectingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Waiting for reconnection…")
	return /** @type {LocalizedString} */ ("En attente de reconnexion…")
});